import { NavigationStepType } from '@/components/NavigationStepper/NavigationStepper';
import { getTwoFAPath } from '../../LoginFlow/TwoFAPage/path/path';
import { getAcceptMasterServiceAgreementPath } from '../AcceptMasterServiceAgreementPage/path';
import { getAdminCompleteRegistrationPath } from '../AdminCompleteRegistrationPage/path/path';
import { getAdminSetPasswordPath } from '../AdminSetPasswordPage/path';
import { getSelectBillingPlanPath } from '../SelectBillingPlanPage/path';
import { getSignUpPath } from '../SignUpPage/path';
import { getSubscriptionCheckoutPath } from '../SubscriptionCheckoutPage/path';
import { getVerifyOtpCodePath } from '../VerifyOtpCodePage/path';
import { SIGN_UP_STEP } from '@/const/shared';
import { TrialDashboardStepperTitle } from './TrialDashboardStepperTitle/TrialDashboardStepperTitle';

export type OnboardingNavigationStep = NavigationStepType & {
  id: string;
  path: string[];
  count: number;
};

const TRIAL_MODE_DASHBOARD_STEP_ID = 'trial_mode_dashboard';

const SUBSCRIPTION_NAVIGATION_STEPS = [
  {
    id: 'sign_agreement',
    title: 'Sign Agreement',
    isActive: false,
    isCompleted: false,
    path: [getAcceptMasterServiceAgreementPath()],
    count: 5,
  },
  {
    id: 'complete_payment',
    title: 'Complete Payment',
    isActive: false,
    isCompleted: false,
    path: [getSelectBillingPlanPath(), getSubscriptionCheckoutPath()],
    count: 6,
  },
];

const ONBOARDING_NAVIGATION_STEPS: OnboardingNavigationStep[] = [
  {
    id: 'create_profile',
    title: 'Create Profile',
    isActive: false,
    isCompleted: false,
    path: [getSignUpPath()],
    count: 1,
  },
  {
    id: 'verify_email',
    title: 'Verify Email',
    isActive: false,
    isCompleted: false,
    path: [getVerifyOtpCodePath()],
    count: 2,
  },
  {
    id: 'verify_phone_number',
    title: 'Verify Phone Number',
    isActive: false,
    isCompleted: false,
    path: [getAdminCompleteRegistrationPath(), getTwoFAPath()],
    count: 3,
  },
  {
    id: 'set_password',
    title: 'Set Password',
    isActive: false,
    isCompleted: false,
    path: [getAdminSetPasswordPath()],
    count: 4,
  },
  {
    id: TRIAL_MODE_DASHBOARD_STEP_ID,
    title: <TrialDashboardStepperTitle />,
    isActive: false,
    isCompleted: false,
    path: [],
    count: 5,
  },
];

const TRIAL_MODE_NAVIGATION_STEPS = [
  ...ONBOARDING_NAVIGATION_STEPS.filter(({ id }) => id !== TRIAL_MODE_DASHBOARD_STEP_ID),
  ...SUBSCRIPTION_NAVIGATION_STEPS,
];

export const ONBOARDING_NAVIGATION_STEPS_MAP = {
  [SIGN_UP_STEP.ONBOARDING]: ONBOARDING_NAVIGATION_STEPS,
  [SIGN_UP_STEP.TRIAL_MODE]: TRIAL_MODE_NAVIGATION_STEPS,
};
